/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteVectorStoreFileRequest = {
  vectorStoreId: string;
  fileId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const DeleteVectorStoreFileRequest$inboundSchema: z.ZodType<
  DeleteVectorStoreFileRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  vector_store_id: z.string(),
  file_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "vector_store_id": "vectorStoreId",
    "file_id": "fileId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type DeleteVectorStoreFileRequest$Outbound = {
  vector_store_id: string;
  file_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const DeleteVectorStoreFileRequest$outboundSchema: z.ZodType<
  DeleteVectorStoreFileRequest$Outbound,
  z.ZodTypeDef,
  DeleteVectorStoreFileRequest
> = z.object({
  vectorStoreId: z.string(),
  fileId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    vectorStoreId: "vector_store_id",
    fileId: "file_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function deleteVectorStoreFileRequestToJSON(
  deleteVectorStoreFileRequest: DeleteVectorStoreFileRequest,
): string {
  return JSON.stringify(
    DeleteVectorStoreFileRequest$outboundSchema.parse(
      deleteVectorStoreFileRequest,
    ),
  );
}
export function deleteVectorStoreFileRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteVectorStoreFileRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteVectorStoreFileRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteVectorStoreFileRequest' from JSON`,
  );
}
